import { createWorkerRequestClient } from '@/utils/workerRequestClient'

export interface HeifWorkerRequest {
  bytes: ArrayBuffer
  quality: number
}

export interface HeifWorkerResponse {
  id: number
  error?: string
  /** The decoder itself never loaded — see `createWorkerRequestClient`. */
  fatal?: boolean
  blob?: Blob
}

const client = createWorkerRequestClient<HeifWorkerRequest, HeifWorkerResponse>(
  'heifWorker',
  () => import('./heifWorkerSpawn').then((module) => module.spawnHeifWorker()),
)

/**
 * Transcodes HEIF bytes to a JPEG blob in the worker, or answers `null` if it
 * couldn't — see `createWorkerRequestClient`; the caller falls back to
 * `HeifConverter`, which decodes on this thread.
 *
 * The bytes are cloned, not transferred: transferring detaches the caller's buffer
 * and the fallback would then be handed empty bytes. Copying a few MB costs a
 * fraction of what the decode does.
 */
export async function tryDecodeHeifInWorker(bytes: Uint8Array, quality: number): Promise<Blob | null> {
  const result = await client.tryRequest({ bytes: bytes.buffer as ArrayBuffer, quality })
  return result?.blob ?? null
}
